<template>
  <div class="container-fluid">
    <div style="display: none!important;">
      <electron-vue-printer ref="electronVuePrinter" :show="true" :options="options" :rotateType="rotateType"
        @webview-ready="Printer" :silent="true">
      </electron-vue-printer>
    </div>
    {{print}}
    <div id="my-node" class="pt-4">
      <div class="text-center" v-if="print_type != ''"><b>{{ print_type }}</b></div>
      <div class="row">
        <!-- sender section -->
        <!-- <div class="col-md-5 header-style">
        <p class="text-center"><b>{{ $t("СОТУВЧИ") }}</b></p>
        <p class="text-center"><b>{{header.sender != null ? header.sender.firm_name : ''}}</b></p>
        <p class="text-center">{{header.sender != null ? header.sender.address : ''}}</p>
        <p>Р/С: {{header.sender != null ? header.sender.p_c : ''}}</p>
        <p>
          <span>МФО: {{header.sender != null ? header.sender.mfo : ''}}&ensp;</span>
          <span>ОКОНХ: {{header.sender != null ? header.sender.oked : ''}}</span>
        </p>
        <p>ИНН: {{header.sender != null ? header.sender.inn : ''}}</p>
        <p>{{header.sender != null ? header.sender.director : ''}}</p><br>
        <p>{{ $t("М.Ў.") }}</p>
      </div> -->
        <div class="col-md-12 text-center">
          <h2 style="width: 100%;">
            {{$t('Начальный остаток')+" №"+datas.number+" от "+Datetime(datas.created_at)}}
          </h2>
          <hr class="hr">
        </div>
        <div class="col-md-3 ml-3">
          {{ $t("ОЛУВЧИ") }}:
        </div>
        <div class="col-md-8">
          <b>{{header.sender != null ? header.sender.firm_name : ''}}</b>
        </div>
        <div class="col-md-3 ml-3">
          {{ $t("Поставщик").toUpperCase() }}:
        </div>
        <div class="col-md-8">
          <b>{{kontragent != null ? kontragent.name : ''}}</b>
        </div>
        <!-- <div class="col-md-2"></div> -->
        <!-- receiver section -->
        <!-- <div class="col-md-5 header-style" v-if="kontragent!=null">
        <p class="text-center"><b>{{ $t("ХАРИДОР") }}</b></p>
        <p class="text-center"><b>{{kontragent.firma != null ? kontragent.firma.name : ''}}</b></p>
        <p class="text-center">{{kontragent != null ? kontragent.address : ''}}</p>
        <p>Р/С: {{kontragent != null ? kontragent.account_number : ''}}</p>
        <p>
          <span>МФО: {{kontragent != null ? kontragent.mfo_id : ''}}&ensp;</span>
          <span>ОКОНХ: {{kontragent != null ? kontragent.okonx : ''}}</span>
        </p>
        <p>ИНН: {{kontragent != null ? kontragent.inn : ''}}</p>
        <p>{{kontragent != null ? kontragent.name : ''}}</p><br>
        <p>{{ $t("М.Ў.") }}</p>
      </div> -->
      </div>
      <!-- table section -->
      <div class="row px-4 my-4">
        <table class="table table-bordered table-sm prints"
          style="width: 19cm; background: none!important; border-radius: 0px!important;">
          <tbody>
            <tr class="text-center">
              <td><b>№</b></td>
              <td><b>Товар</b></td>
              <td><b>{{$t('Кол.')}}</b></td>
              <td><b>{{ $t("Нарх") }}</b></td>
              <td><b>Сумма</b></td>
            </tr>
            <tr v-for="(item, index) in datas.initial_balance_table" :key="index">
              <td class="text-center">{{ index + 1 }}</td>
              <td>{{ item.product != null ? item.product.extra_name: "" }}</td>
              <td class="kol">{{ item.count|numFormat }}</td>
              <td class="kol">{{ item.debit_price|numFormat }}</td>
              <td class="kol">{{ item.debit_summa |numFormat }}</td>
            </tr>
            <tr>
              <td colspan="2" class="text-center"><b>{{ $t("Жами") }}:</b></td>
              <td class="kol"><b>{{ all_count|numFormat }}</b></td>
              <td class="kol"><b>{{ all_price|numFormat }}</b></td>
              <td class="kol"><b>{{ all_summa|numFormat }}</b></td>
            </tr>
          </tbody>
        </table>
        <!-- <p style="width:100%; display: block">{{ $t("Етказиб берилган товарларнинг умумий қиймати:") }} {{datas.summa|numFormat}}</p> -->
        <!-- <div class="col-md-6"></div>
        <div class="col-md-3">{{$t('Итого')}}:</div>
        <div class="col-md-3 end"><b>{{datas.summa|numFormat}}</b></div>
        <div class="col-md-6"></div>
        <div class="col-md-3">{{$t('Без налога (НДС)')}}:</div>
        <div class="col-md-3 end"></div>
        <div class="col-md-6"></div>
        <div class="col-md-3">{{$t('Отгружено на сумму')}}:</div>
        <div class="col-md-3 end"><b>{{datas.summa|numFormat}}</b></div> -->
        <div class="col-md-12">
          <b>{{$t('Всего наименований')+" "+all_count+", на сумму "}}{{all_summa|numFormat}}</b>
        </div>
      </div>
      <div class="row font-point">
        <div class="col-md-2">
          <span>{{ $t("Отпустил") }}:</span>
        </div>
        <div class="col-md-4">
          <hr class="imzo">
          <b class="imzotext">{{$t('Имзо')}}</b>
        </div>
        <div class="col-md-4">
          <hr class="imzo">
          <b class="imzotext">{{$t('Расшировка подписи')}}</b>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-2">
          <span>{{ $t("Получил") }}:</span>
        </div>
        <div class="col-md-4">
          <hr class="imzo">
          <b class="imzotext">{{$t('Имзо')}}</b>
        </div>
        <div class="col-md-4">
          <hr class="imzo">
          <b class="imzotext">{{$t('Расшировка подписи')}}</b>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-12">
          <center>{{$t('М.Ў.')}}</center>
        </div>
        <!-- <div class="col-md-5">{{header.sender != null ? header.sender.director : ''}}</div> -->
      </div>
    </div>
  </div>
</template>
<script>
  import * as htmlToImage from "html-to-image";
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
  import electronVuePrinter from "electron-vue-printer";
  export default {
    components: { electronVuePrinter, htmlToImage },
    data() {
      return {
        header: {
          sender: null,
          receiver: null
        },
        datas: [],
        kontragent: null,
        qarz: 0,
        qarz_dollar: 0,
        mysklad: [],
        print: 'false',
        print_type: '',
        rotateType: 0,
        options: {
          offsetX: 0,
          offsetY: 0
        },
        all_count: 0,
        all_price: 0,
        all_summa: 0,
      }
    },
    async updated() {
      if (this.print == 'print') {
        this.$refs.electronVuePrinter.deviceNamePrint = this.header.printer_name;
        await this.$refs.electronVuePrinter.print(this.dataUrl);
      }
    },
    created: function () {
      this.GetHeader();
      this.GetTable();
      if (localStorage.getItem("print_type")) {
        this.print_type = localStorage.getItem("print_type");
      }
    },
    methods: {
      data_await(){
        let self = this;
        if(self.header.printer_name && self.datas.created_at){
          self.Starprinting(true);
        }else{
          self.data_await()
        }
      },
      Convert(number) {
        var NS = [
          { value: 10000000000, str: "миллиарт" },
          { value: 10000000, str: "миллион" },
          { value: 1000, str: "тысяча" },
          { value: 100, str: "сто" },
          { value: 90, str: "девяносто" },
          { value: 80, str: "восемьдесят" },
          { value: 70, str: "семьдесят" },
          { value: 60, str: "шестьдесят" },
          { value: 50, str: "пятьдесят" },
          { value: 40, str: "сорок" },
          { value: 30, str: "тридцать" },
          { value: 20, str: "двадцать" },
          { value: 19, str: "девятнадцать" },
          { value: 18, str: "восемнадцать" },
          { value: 17, str: "семнадцать" },
          { value: 16, str: "шестнадцать" },
          { value: 15, str: "пятнадцать" },
          { value: 14, str: "четырнадцать" },
          { value: 13, str: "тринадцать" },
          { value: 12, str: "двенадцать" },
          { value: 11, str: "одиннадцать" },
          { value: 10, str: "десять" },
          { value: 9, str: "девять" },
          { value: 8, str: "восемь" },
          { value: 7, str: "семь" },
          { value: 6, str: "шесть" },
          { value: 5, str: "пять" },
          { value: 4, str: "четыре" },
          { value: 3, str: "три" },
          { value: 2, str: "два" },
          { value: 1, str: "один" }
        ];
        var result = '';
        for (var n of NS) {
          if (number >= n.value) {
            if (number <= 99) {
              result += n.str;
              number -= n.value;
              if (number > 0) result += ' ';
            } else {
              var t = Math.floor(number / n.value);
              // console.log(t);
              var d = number % n.value;
              if (d > 0) {
                return this.Convert(t) + ' ' + n.str + ' ' + this.Convert(d);
              } else {
                return this.Convert(t) + ' ' + n.str;
              }

            }
          }
        }
        return result;
      },
      Datetime(date) {
        var d = new Date(date * 1000);
        var dt = d.getDate();
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        if (dt < 10) {
          dt = "0" + dt;
        }

        return dt + "-" + month + "-" + d.getFullYear();
      },
      Starprinting(data){
        if (data == true) {
          setTimeout(() => {
            localStorage.removeItem("print_type");
            window.close();
          }, 1000);
        }
      },
      async Printer() {
        if(this.header.printer_name && this.datas.created_at){
          let self = this;
          var node = document.getElementById("my-node");
          await htmlToImage
            .toSvg(document.getElementById("my-node"))
            .then(function (dataUrl) {
              self.dataUrl = dataUrl;
              self.print = 'print';
            })
            .catch(function (error) {
              console.error("oops, something went wrong!", error);
            });
          }else{
          console.log('no')
          setTimeout(() => {
            this.Printer()
          }, 1000);
        }
      },
      GetHeader(){
        let self = this;
        axios({
          method: "post",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
        }).then(function (response) {
          if (response.data.data != null) {
            self.header = JSON.parse(response.data.data);
          }
        });
      },
      GetTable(){
        let self = this;
        axios({
          method: "get",
          url: "api/v1/initial-balance/id/" + self.$route.params.id
        }).then(function (response) {
          self.datas = response.data;
          self.Mysklad();
          if(response.data.kontragent_id>0){
            self.GetKontragent(response.data.kontragent_id);
            self.Qarzdorlik();
          }
          self.Summa();
          setTimeout(() => {
            self.data_await()
          }, 3000);
        });
      },
      GetKontragent(id){
        let self = this;
        axios({
          method: "get",
          url: "api/v1/kontragent/id/" + id
        }).then(function (response) {
          self.kontragent = response.data;
        });
      },
      Qarzdorlik() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/kontragent/total",
          data: {
            kontragent_id: self.datas.kontragent_id,
            sklad_id: self.datas.sklad_id,
            datetime: self.datas.created_at
          }
        }).then(function (response) {
          response.data.forEach(function (key, value) {
            if (key.pay_type_id == 3) {
              self.qarz = key.total;
            } else {
              self.qarz_dollar = key.total;
            }
          });
          self.print = true;
        });
      },
      Mysklad() {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/sklads/id/" + self.datas.sklad_id
        }).then(function (response) {
          self.mysklad = response.data;
        });
      },
      Summa(){
        this.all_count = 0;
        this.all_price = 0;
        this.all_summa = 0;
        this.datas.initial_balance_table.forEach(element => {
          this.all_count += element.count;
          this.all_price += element.debit_price;
          this.all_summa += element.debit_summa;
        });
      }
    }
  }
</script>
<style scoped>
  .prints td,
  th {
    border-color: black;
  }

  #my-node {
    width: 21cm;
    min-height: 29.7cm;
    height: auto !important;
    padding: 0 10px;
    margin: 8px;
  }

  .header-style {
    border: 1px solid;
    border-radius: 12px;
    margin: 1rem auto;
  }

  .header-style>p {
    font-size: 14pt !important;
    line-height: 1.2em;
    margin: 0.4em auto;
    padding: 0 10px;
  }

  .font-point {
    font-size: 14pt !important;
    margin: 1rem auto;
  }
</style>